<template>
  <div class="client-eb-dnf">
    <h2>Early Bird Enrollments NOT Shown in Tax Software <span v-if="!isLoading">{{ tableData.length }} total</span></h2>
    <el-table :data="tableData" style="width: 100%" v-loading="isLoading" stripe class="client-eb-dnf-table" @row-dblclick="onRowDoubleClick">
      <el-table-column prop="ssn" label="SSN" width="120" sortable/>
      <el-table-column prop="firstName" label="First Name" width="200" sortable/>
      <el-table-column prop="lastName" label="Last Name" sortable/>
      <el-table-column prop="enrolledDate" label="Enrolled Date" sortable/>
      <el-table-column prop="officeId" label="Office" width="125" sortable>
        <template slot-scope="scope">
          {{ (officeMap[scope.row.officeId] ? officeMap[scope.row.officeId].efin : '') }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import api from '@/api';
import ReportData from '@/mixin/ReportData';

export default {
  name: 'EBDidNotFileTable',
  mixins: [ReportData],
  data() {
    return {
      isLoading: false,
      tableData: [],
    };
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
    fetchData() {
      this.isLoading = true;
      api.report.getEarlyBirdDNF(this.forOffice).then((response) => {
        this.tableData = response.data;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onRowDoubleClick(row) {
      this.$router.push({ name: 'clientDetail', params: { id: row.id } });
    },
  },
  computed: {
    ...mapGetters('Lookup', ['officeMap']),
  },
  mounted() {
    this.fetchData();
    this.getOffices();
  },
};

</script>

<style lang="scss">
  .client-eb-dnf {
    h2 span {
      color: #999;
      font-size: 0.8em;
      text-transform: uppercase;
      font-weight: normal;
    }

    .client-eb-dnf-table .el-table__body-wrapper {
      max-height: 400px;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
</style>
